import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Product.scss';

export default function ReadyBuilds() {
  const [builds, setBuilds] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(
          'https://sheets.googleapis.com/v4/spreadsheets/1usVfJ-1O_wRD5fcLxVQVfskcSQ-L6hmDp2kvFckvGO8/values/Лист1!A:F?key=AIzaSyAbLqcy6h2MPUSuWJh93fUax3NIAUPtgv8'
        );
        const data = await res.json();

        const rows = data.values;
        if (!rows || rows.length < 2) return;

        // ✅ преобразуем строки в объекты
        const headers = rows[0];
        const items = rows.slice(1).map((row) => {
          const obj = {};
          headers.forEach((h, i) => (obj[h.trim().toLowerCase()] = row[i] || ''));
          return obj;
        });

        // ✅ фильтруем по категории "readybuilds"
        const readyBuildItems = items.filter(
          (item) => item.category?.trim().toLowerCase() === 'readybuilds'
        );

        setBuilds(readyBuildItems);
      } catch (err) {
        console.error('Ошибка при загрузке данных:', err);
      }
    }

    fetchData();
  }, []);

  return (
    <div className="products">
      <h1>Готовые сборки</h1>
      <div className="products__list">
        {builds.length > 0 ? (
          builds.map((build) => (
            <div key={build.id} className="products__card">
              <img src={build.image} alt={build.name} />
              <h2>{build.name}</h2>
              <p className="specs">{build.description}</p>
              <p className="price">{build.price}</p>
              <Link to={`/ready-builds/${build.id}`} className="btn">
                Подробнее
              </Link>
            </div>
          ))
        ) : (
          <p>Загрузка...</p>
        )}
      </div>
    </div>
  );
}
